import { render } from "./ScreeningsView.vue?vue&type=template&id=dc777158"
const script = {}

import "./ScreeningsView.vue?vue&type=style&index=0&id=dc777158&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__